// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/concentration_summary_mean_result.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { SampleType } from "../../../common/types/v1/sample_type_pb";
import { file_quanterix_common_types_v1_sample_type } from "../../../common/types/v1/sample_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/concentration_summary_mean_result.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_concentration_summary_mean_result: GenFile = /*@__PURE__*/
  fileDesc("Ck9xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY29uY2VudHJhdGlvbl9zdW1tYXJ5X21lYW5fcmVzdWx0LnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEi0QMKHkNvbmNlbnRyYXRpb25TdW1tYXJ5TWVhblJlc3VsdBIfChJyZXBsaWNhdGVfZ3JvdXBfaWQYASABKAlIAIgBARIWCglzYW1wbGVfaWQYAiABKAlIAYgBARIYCgtzYW1wbGVfbmFtZRgDIAEoCUgCiAEBEj8KC3NhbXBsZV90eXBlGAQgASgOMiUucXVhbnRlcml4LmNvbW1vbi50eXBlcy52MS5TYW1wbGVUeXBlSAOIAQESHQoIYXNzYXlfaWQYBSABKAlCBoK1GAIYAUgEiAEBEhQKB3BsZXhfaWQYBiABKAlIBYgBARIWCglwbGV4X25hbWUYByABKAlIBogBARIZCgxkaXNwbGF5X3VuaXQYCCABKAlIB4gBARIfChJtZWFuX2NvbmNlbnRyYXRpb24YCSABKAFICIgBAUIVChNfcmVwbGljYXRlX2dyb3VwX2lkQgwKCl9zYW1wbGVfaWRCDgoMX3NhbXBsZV9uYW1lQg4KDF9zYW1wbGVfdHlwZUILCglfYXNzYXlfaWRCCgoIX3BsZXhfaWRCDAoKX3BsZXhfbmFtZUIPCg1fZGlzcGxheV91bml0QhUKE19tZWFuX2NvbmNlbnRyYXRpb25iBnByb3RvMw", [file_quanterix_common_extensions_v1_field_options, file_quanterix_common_types_v1_sample_type]);

/**
 * Represents a summary analysis result for a single replicate group.
 *
 * Calculated mean concentrations for each plex region
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ConcentrationSummaryMeanResult
 */
export type ConcentrationSummaryMeanResult = Message<"quanterix.simoa_one.analysis_app_api.v1.ConcentrationSummaryMeanResult"> & {
  /**
   * Unique id (UUID) for the replicate group associated with this result
   *
   * @generated from field: optional string replicate_group_id = 1;
   */
  replicateGroupId?: string;

  /**
   * Unique id (UUID) for the sample associated with this result
   *
   * @generated from field: optional string sample_id = 2;
   */
  sampleId?: string;

  /**
   * Friendly name of the sample for display
   *
   * @generated from field: optional string sample_name = 3;
   */
  sampleName?: string;

  /**
   * Sample type (e.g. Calibrator, Control, Sample)
   *
   * @generated from field: optional quanterix.common.types.v1.SampleType sample_type = 4;
   */
  sampleType?: SampleType;

  /**
   * Unique id (UUID) for the assay associated with this result
   *
   * @generated from field: optional string assay_id = 5;
   */
  assayId?: string;

  /**
   * Unique id (UUID) for the plex associated with this result
   *
   * @generated from field: optional string plex_id = 6;
   */
  plexId?: string;

  /**
   * Friendly name of the plex for display
   *
   * @generated from field: optional string plex_name = 7;
   */
  plexName?: string;

  /**
   * Concentration unit represented as a string for display
   *
   * @generated from field: optional string display_unit = 8;
   */
  displayUnit?: string;

  /**
   * Mean Concentration value
   *
   * @generated from field: optional double mean_concentration = 9;
   */
  meanConcentration?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ConcentrationSummaryMeanResult.
 * Use `create(ConcentrationSummaryMeanResultSchema)` to create a new message.
 */
export const ConcentrationSummaryMeanResultSchema: GenMessage<ConcentrationSummaryMeanResult> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_concentration_summary_mean_result, 0);

